/**
 * Id пользователя для статичного QR.
 *
 * В сторе он есть только пока жив профиль из `/user/me`; без сети профиль
 * не загрузится, а показывать код нужно. Поэтому id кладём в localStorage при
 * каждой успешной загрузке профиля и стираем при выходе — статичный код
 * чужого аккаунта хуже, чем никакого.
 */
const LOYALTY_USER_ID_KEY = 'loyaltyUserId';

export const saveLoyaltyUserId = (userId: string) => {
  try {
    localStorage.setItem(LOYALTY_USER_ID_KEY, userId);
  } catch {
    // Приватный режим: без хранилища офлайн-код просто не соберётся.
  }
};

export const readLoyaltyUserId = (): string | null => {
  try {
    return localStorage.getItem(LOYALTY_USER_ID_KEY);
  } catch {
    return null;
  }
};

export const clearLoyaltyUserId = () => {
  try {
    localStorage.removeItem(LOYALTY_USER_ID_KEY);
  } catch {
    // Нечего чистить.
  }
};
